import { useState } from "react";
import { useModal } from "../context/ModalContext";

import { subscribeNewsletter } from "../api/newsletters"; // TODO: implement this API call in src/api/newsletter.js

const NewsletterModal = () => {
  const { showModal, handleClose, handleSubscribed } = useModal();
  const [email, setEmail] = useState("");
  const [submitted, setSubmitted] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState("");

  if (!showModal) return null;

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!email.trim()) {
      setError("Please enter your email address");
      return;
    }
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(email)) {
      setError("Please enter a valid email address");
      return;
    }

    setError("");
    setSubmitting(true);
    try {
      const res = await subscribeNewsletter(email);
      if (res?.status !== "ok") throw res?.error || "Something went wrong";
      setSubmitted(true);
      handleSubscribed();
    } catch (err) {
      setError(
        typeof err === "string"
          ? err
          : "Something went wrong. Please try again.",
      );
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <>
      {/* Backdrop */}
      <div
        onClick={handleClose}
        style={{
          position: "fixed",
          inset: 0,
          backgroundColor: "rgba(0,0,0,0.5)",
          zIndex: 1055,
        }}
      />

      {/* Modal */}
      <div
        style={{
          position: "fixed",
          inset: 0,
          zIndex: 1060,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          padding: 16,
          pointerEvents: "none",
        }}
      >
        <div
          style={{
            backgroundColor: "#fff",
            width: "100%",
            maxWidth: 480,
            borderRadius: 12,
            overflow: "hidden",
            pointerEvents: "all",
            boxShadow: "0 20px 60px rgba(0,0,0,0.2)",
          }}
        >
          {/* ── Top Image ── */}
          <div style={{ position: "relative" }}>
            <img
              src="/assets/images/heroBanner.png"
              alt="HueHoppers"
              style={{ width: "100%", height: 300, objectFit: "cover" }}
              onError={(e) => {
                e.currentTarget.style.background =
                  "linear-gradient(135deg, #f4f3ef 0%, #e8e4dc 100%)";
                e.currentTarget.style.height = "120px";
              }}
            />
            {/* Close button */}
            <button
              onClick={handleClose}
              style={{
                position: "absolute",
                top: 12,
                right: 12,
                background: "rgba(255,255,255,0.9)",
                border: "none",
                borderRadius: "50%",
                width: 32,
                height: 32,
                fontSize: 18,
                cursor: "pointer",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                fontWeight: 700,
                color: "#2c3a34",
              }}
            >
              ×
            </button>
          </div>

          {/* ── Content ── */}
          <div style={{ padding: "32px 32px 24px" }}>
            {!submitted ? (
              <>
                {/* Heading */}
                <h4
                  style={{
                    fontSize: 30,
                    fontWeight: 700,
                    color: "#2c3a34",
                    marginBottom: 8,
                    textAlign: "center",
                    lineHeight: 1.3,
                  }}
                >
                  Your child's mood is waiting.
                </h4>
                {/* Subheading */}
                <p
                  style={{
                    fontSize: 15,
                    color: "#555",
                    textAlign: "center",
                    marginBottom: 24,
                    lineHeight: 1.6,
                  }}
                >
                  Join the HueHoppers family and receive{" "}
                  <span style={{ fontWeight: 700, color: "#3a00ac" }}>
                    15% off
                  </span>{" "}
                  your first order.
                </p>
                {/* Form */}
                <form onSubmit={handleSubmit}>
                  <div style={{ marginBottom: 12 }}>
                    <input
                      type="email"
                      value={email}
                      onChange={(e) => {
                        setError("");
                        setEmail(e.target.value);
                      }}
                      placeholder="Your email address"
                      style={{
                        width: "100%",
                        padding: "12px 16px",
                        border: `1px solid ${error ? "#c62828" : "#ddd"}`,
                        borderRadius: 6,
                        fontSize: 14,
                        outline: "none",
                        color: "#2c3a34",
                        fontFamily: "inherit",
                      }}
                    />
                    {error && (
                      <p
                        style={{ color: "#c62828", fontSize: 12, marginTop: 4 }}
                      >
                        {error}
                      </p>
                    )}
                  </div>

                  <button
                    type="submit"
                    disabled={submitting}
                    className="tf-btn w-100 btn-fill"
                    style={{
                      opacity: submitting ? 0.7 : 1,
                      cursor: submitting ? "not-allowed" : "pointer",
                    }}
                  >
                    {submitting ? "Hopping in..." : "Hop In 🌈"}
                  </button>
                </form>
                {/* Fine print */}
                <p
                  style={{
                    fontSize: 12,
                    color: "#aaa",
                    textAlign: "center",
                    marginTop: 16,
                    marginBottom: 0,
                  }}
                >
                  No spam. Just good moods.
                </p>
                {/* Not interested */}
                <div style={{ textAlign: "center", marginTop: 12 }}>
                  <button
                    onClick={handleClose}
                    style={{
                      background: "none",
                      border: "none",
                      fontSize: 15,
                      color: "#888",
                      cursor: "pointer",
                      textDecoration: "underline",
                    }}
                  >
                    Not interested
                  </button>
                </div>
              </>
            ) : (
              // ── Success state ──
              <div style={{ textAlign: "center", padding: "16px 0" }}>
                <div style={{ fontSize: 48, marginBottom: 16 }}>🌈</div>
                <h4
                  className="font-gloock"
                  style={{ fontSize: 22, color: "#2c3a34", marginBottom: 8 }}
                >
                  Welcome to the family!
                </h4>
                <p
                  style={{
                    fontSize: 14,
                    color: "#555",
                    marginBottom: 24,
                    lineHeight: 1.6,
                  }}
                >
                  Your 15% off coupon is on its way to <strong>{email}</strong>.
                  <br />
                  Check your inbox! 📬
                </p>
                <button
                  type="submit"
                  onClick={handleClose}
                  className="tf-btn w-100 btn-fill"
                  style={{
                    opacity: submitting ? 0.7 : 1,
                    cursor: submitting ? "not-allowed" : "pointer",
                  }}
                >
                  Start Shopping
                </button>
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default NewsletterModal;
